// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Image_wrapper__EhogO","image":"Image_image__1ZNIi","skeleton":"Image_skeleton__fBEC8"};